import { whatsNew_FlexPane_Title } from 'owa-locstrings/lib/strings/whatsnew_flexpane_title.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import { observer } from 'mobx-react-lite';
import { WhatsNewContainer } from 'owa-whats-new';

export default observer(function WhatsNewPane({ onDismiss }: HeaderPaneProps) {
    return (
        <HeaderFlexPane
            title={loc(whatsNew_FlexPane_Title)}
            content={<WhatsNewContainer />}
            onDismiss={onDismiss}
        />
    );
});
